import { z } from "zod";

export const SUPPORTED_BULK_UPLOAD_TEMPLATE_VERSIONS = ["1.0"] as const;

// Legacy quote workbooks have no metadata sheet, but the API requires a version.
export const LEGACY_BULK_UPLOAD_TEMPLATE_VERSION =
	SUPPORTED_BULK_UPLOAD_TEMPLATE_VERSIONS[0];

export const carrierPreferenceSchema = z.enum([
	"lowest_cost",
	"lowest_cost_fastest",
	"lowest_cost_preferred",
	"manual",
]);

export const bulkUploadTemplateMetadataSchema = z
	.object({
		templateType: z.enum(["quote", "tender"]),
		templateVersion: z.enum(SUPPORTED_BULK_UPLOAD_TEMPLATE_VERSIONS),
		headerRow: z.coerce.number().int().positive(),
		dataStartRow: z.coerce.number().int().positive(),
	})
	.refine((metadata) => metadata.dataStartRow > metadata.headerRow, {
		message: "dataStartRow must be after headerRow.",
		path: ["dataStartRow"],
	});

export const bulkUploadAcceptedSchema = z.object({
	bulkQuoteId: z.string().uuid(),
	requestCount: z.number().int().positive(),
	status: z.literal("accepted"),
});

export const bulkUploadResponseSchema = bulkUploadAcceptedSchema;

export type BulkUploadAccepted = z.infer<typeof bulkUploadAcceptedSchema>;
export type BulkUploadResponse = z.infer<typeof bulkUploadResponseSchema>;
export type BulkUploadTemplateMetadata = z.infer<
	typeof bulkUploadTemplateMetadataSchema
>;
